var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-button',{staticClass:"w-full",attrs:{"color":"success","type":"filled","icon-pack":"feather","icon":"icon-download","disabled":_vm.client == null},on:{"click":_vm.handleClick}},[_vm._v("\n    "+_vm._s(_vm._f("capitalize")(_vm.$t('export')))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }